const GIVING_CATEGORIES = new Set([
  "general",
  "tithe",
  "offering",
  "campaign",
  "building",
  "missions",
  "benevolence",
  "program",
  "event",
  "other",
]);

function cleanText(value) {
  return String(value || "").trim();
}

export function normalizeGivingPlatformCategory(value, fallback = "general") {
  const safe = cleanText(value).toLowerCase().replace(/\s+/g, "_");
  if (safe === "tithes") return "tithe";
  if (safe === "offerings") return "offering";
  if (safe === "building_fund" || safe === "building-fund") return "building";
  if (safe === "mission") return "missions";
  if (GIVING_CATEGORIES.has(safe)) return safe;
  return fallback;
}

export function resolveDonationIntent(input = {}) {
  const platformCategory = normalizeGivingPlatformCategory(
    input.platformCategory || input.givingCategory || input.category,
    "general"
  );
  const bucketLabel = cleanText(
    input.bucketLabel ||
      input.label ||
      input.givingCategoryLabel ||
      input.campaignTitle ||
      input.campaignName
  );
  const defaultAmount = Number(input.amount || input.defaultAmount || 0);

  return {
    transactionPurpose: "giving",
    bucketId: cleanText(input.bucketId) || null,
    bucketLabel: bucketLabel || "General Donation",
    platformCategory,
    campaignId: cleanText(input.campaignId) || null,
    campaignTitle: cleanText(input.campaignTitle || input.campaignName) || null,
    defaultAmount: Number.isFinite(defaultAmount) && defaultAmount > 0 ? defaultAmount : null,
    recurringDefault: input.recurring === true || input.recurringDefault === true,
    sourceContext: cleanText(input.sourceContext) || "public_site",
  };
}
